<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
      <b>Version</b> 1.0.0
    </div>
    Automatad &copy; 2018 <a href="#"><strong>Yeti</strong></a>. Made with love
  </footer>
</template>

<script>
  export default {
    name: 'DashboardFooter'
  }
</script>




// WEBPACK FOOTER //
// Footer.vue?13db1808